import { useMutation, useQueryClient } from '@gogame/query';

import { setReceiveNotifications } from 'scenes/PromoCodes/sources/promoCodes';
import { details, setReceiveNotifications as key } from '../queryKeyFactory';
import { errorMessageGetter } from './useErrorDifferentFormatGetter';

export const useUpdateReceiveNotifications = (id) => {
  const queryClient = useQueryClient();

  const updateMutation = useMutation(key(), setReceiveNotifications, {
    errorMessage: errorMessageGetter,
    refresh: false,
  });

  const handleAction = async ({ value }) => {
    queryClient.setQueriesData(
      {
        queryKey: details(id),
        exact: true,
      },
      (old) => ({
        ...old,
        receiveNotifications: value,
      })
    );
    await updateMutation.mutateAsync({ receiveNotifications: value, id });
  };
  return [handleAction, updateMutation];
};
